import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getClientInputs = async ({ commit }, id) => {
  let url = `/clients/${id}/inputs`;
  await connection.get(url)
    .then(res => {
      const clients = res.data.data;
      commit('setClientInputsLength', clients);
    }).catch(err => {
      console.log('error', err);
    });
}

export const getClientOutputs = async ({ commit }, id) => {
  let url = `/clients/${id}/outputs`;
  await connection.get(url)
    .then(res => {
      const clients = res.data.data;
      console.log(id);
      console.log(res.data.data);
      commit('setClientOutputsLength', clients);
    }).catch(err => {
      console.log('error', err);
    });
}

export const getProductsByClient = async ({ commit }, id) => {
  let url = `/clients/${id}/products`;
  commit('setClientProductsIsLoading', true);
  await connection.get(url)
    .then(res => {
      commit('setClientProducts', res.data.data);
      commit('setClientProductsIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setClientProductsIsLoading', false);
    });
}


export const getClients = async ({ commit }) => {
  let url = `/clients/selectable`;
  await connection.get(url)
    .then(res => {
      const clients = res.data.data;
      commit('setClientsSelectable', clients);
    }).catch(err => {
      console.log('error', err);
    });
}

export const loadClients = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setClientIsLoading', true);
    let url = `/clients`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        console.log(res);
        const clients = res.data.data;
        commit('setClients', clients);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setClientsPaginated', res.data);
        commit('setClientIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setClientIsLoading', false);
      });
}

export const clientById = async ({ commit }, id) => {
  commit('setClientIsLoading', true);
  await connection.get(`/clients/${id}`)
    .then(res => {
      commit('setClientDetail', res.data.data);
      commit('setClientIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setClientIsLoading', false);
    });
}

export const storeClient = async ({ commit }, client) => {
  commit('setClientIsCreating', true);
  await connection.post(`/clients/create`, client)
    .then(res => {
      console.log(res.data);
      commit('saveNewClients', res.data);
      commit('setClientIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setClientIsCreating', false);
    });
}

export const updateClient = async ({ commit }, client ) => {
  commit('setClientIsUpdating', true);
  await connection.put(`/clients/${client.id}/update`, client)
    .then(res => {
      commit('saveUpdatedClient', res.data);
      commit('setClientIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setClientIsUpdating', false);
    });
}

export const deleteClient = async ({ commit }, client) => {
  commit('setClientIsDeleting', true);
  await connection.delete(`/clients/${client.id}/delete`)
    .then(res => {
      commit('setDeleteClient', res.data);
      commit('setClientIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setClientIsDeleting', false);
    });
}
